import React from 'react'
import PublicationTable from './components/PublicationTable'

export default function index() {
    return (
        <div className="mt-1 flex flex-col items-start">
            <PublicationTable />
        </div>
    )
}
